<template>
    <div class="about" v-if="table.length > 0">
        <div class="df both-side vertical about-text-wrapper">
            <div class="line"></div>
            <div class="about-text">
                点击了解其他相关信息
            </div>
            <div class="line"></div>
        </div>

        <div class="about-item-wrapper">
            <template v-for="(item, index) in table" :key="index">
                <div class="about-item" :class="[active === item.id ? 'active' : '']" @click="handleToJump(item)">
                    <img src="@/assets/img/mobile/page/about-link-unActive.png" alt="" v-if="active !== item.id">
                    <img src="@/assets/img/mobile/page/about-link-active.png" alt="" v-else>
                    <span>{{ item.model }}</span>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { defineComponent, reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { getProductInfoList } from '@/request/view/productPublicityDept.js'
import { aboutType } from '../../Literature/data';

export default defineComponent({
    props: {
        type: String,
    },
    setup(props) {
        const router = useRouter();

        const table = reactive([]);

        const getAbout = () => {
            table.length = 0;
            getProductInfoList({
                catalog: aboutType,
                product: props.type
            }).then((res) => {
                if (res.code === 200 && res.message === '成功' && res.data) {
                    const canUseList = res.data.filter((f) => f.isDeactivate === false);
                    table.push(...canUseList);

                }
            });
        };

        getAbout();

        const active = ref(null);

        const handleToJump = (record) => {
            active.value = record.id;
            const { catalog, product, model, id } = record;

            console.log(record, '++++++++++++++++');

            router.push({
                url: '/branddetails',
                query: {
                    id
                }
            })
        };

        return {
            table,
            active,
            handleToJump,
        };
    }
});
</script>

<style lang="less" scoped>
.about {
    padding: 0 0.54rem 1.28rem;

    .about-text-wrapper {
        margin-bottom: 0.6rem;

        .line {
            margin: 0;
        }

        .about-text {
            width: 15rem;
            text-align: center;
            font-size: 0.36rem;
            color: #B2B2B2;
        }
    }

    .about-item-wrapper {
        .about-item {
            width: 6.69rem;
            height: 1.08rem;
            margin: 0 auto 0.4rem;
            background: url('../../../../assets/img/page/company_about.png');
            background-size: 100% 100%;
            border-radius: 0.28rem;
            font-weight: bold;
            font-size: 0.32rem;
            color: #fff;
            text-align: left;
            padding-left: 0.46rem;
            display: flex;
            align-items: center;

            img {
                width: 0.41rem;
                height: 0.41rem;
                margin-right: 0.17rem;
            }
        }

        .active {
            background: #02C4C8;
            color: #FFFFFF;
        }
    }
}
</style>
